<template>
    <div>
        <b-modal id="modal-prevent-closing" class="header-modal" no-close-on-backdrop hide-footer ref="modal-recovery">
            <div class="modal-recovery__body">
                <h4>
                    <strong>
                        Thu hồi
                    </strong>
                </h4>
                <p class="font-size-20 text-center primary-color-txt font-sanpro-light">
                    Bạn có chắc chắn thu hồi <strong>{{ dataLesson.name }}</strong> với {{ itemCurrentSelected.groupId>0?'nhóm':'lớp' }} <strong>{{ itemCurrentSelected.name }}</strong> không?
                </p>
                <div class="modal__actions text-right">
                    <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel" @click="handleHideModal">Hủy</a>
                    <a href="javascript:;" class="btn btn-err font-size-17 font-sanpro-semibold btn-delete" @click="handleDelete()">Đồng ý</a>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import {recoveryLessonClassSchoolId,recoveryLessonGroupId } from './../../../_api/LessonClassSchoolServices'
export default {
    name: "ModalRecoveryAssign",
    props: {
        dataLesson: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        itemCurrentSelected:{
            type:Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default:{}
        },
        type:{
            type:Number,
            // eslint-disable-next-line vue/require-valid-default-prop
            default:0
        }
    },
    data() {
        return {
            confirmActive: {},
            isLoading: false,
        }
    },
    mounted(){
        this.handleShowModal()
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        
    },
    methods: {
        recoveryByClassSchoolId(){
            recoveryLessonClassSchoolId({type:this.type,classSchoolId:this.itemCurrentSelected.classSchoolId,id:this.dataLesson.id}).then((res)=>{
                if (res && res.data && !res.errors) {
                    this.$toast.success('Thu hồi thành công')
                    //this.getListClassGroupAssign()
                    //this.isShowAssignLesson = false
                    this.handleDone()
                }
            })
        },
        recoveryByGroupId(){
            recoveryLessonGroupId({type:this.type,groupId:this.itemCurrentSelected.groupId,id:this.dataLesson.id}).then((res)=>{
                if (res && res.data && !res.errors) {
                    this.$toast.success('Thu hồi thành công')
                    //this.getListClassGroupAssign()
                    //this.isShowAssignLesson = false
                    this.handleDone()
                }
            })
        },
        handleDelete() {
            if(this.itemCurrentSelected.groupId>0){
                this.recoveryByGroupId()
            }
            else{
                this.recoveryByClassSchoolId()
            }
        },
        handleDone(){
            this.$emit('handelRecoveryDone')
            this.handleHideModal()
        },
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-recovery'].show()
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-content {
    background-color: red;
}

.modal-recovery__body {
    padding: 20px;
    background-color: white;
    border-radius: 15px;
    .modal__actions{
        
        .btn-delete{
            color: white;
            background: #fe0201;
            padding: 5px 20px 5px 20px;
            border-radius: 15px;
            font-family: sans-serif;
        }
        .btn-cancel{
            margin-right: 10px;
            font-family: sans-serif;
        }
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>